/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 1rem 0rem",
  },
  heading: {
    width: "100%",
    color: "#CC0000",
    background: "-webkit-linear-gradient(90deg, #74378E, #502761)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    fontWeight: "600",
    fontSize: "1.75rem",
    lineHeight: "3.1875rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "2.25rem",
    },
  },
  subHeading: {
    margin: "0.2rem 0rem 0.2rem 0rem",
    width: "100%",
    color: "#666666",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "2.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "2.5rem",
    },
  },
  table: {
    borderCollapse: "collapse",
    padding: "1rem",
  },
  tableContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "2rem",
  },
}));

const RefundPolicy = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Typography
          variant="h4"
          component="span"
          className={classes.heading}
        >
          TERMS & CONDITIONS FORMING PART OF THE APPLICATION FOR ALLOTMENT OF A RESIDENTIAL APARTMENT
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          <b>The broad terms and conditions for allotment of the unit is as mentioned below:</b>
        </Typography>

        <Typography
          variant="body2"
          component="span"
          className={classes.subHeading}
        >
          <ol>
            <li>
              &nbsp; The Applicant has applied for the allotment of a Unit by paying the booking amount after reading
              and understanding the terms and conditions of this Application. Subscribing to the application by the
              Applicant/s amounts to deemed acceptance of all the terms and conditions specified herein.
            </li>
            <li>
              &nbsp; The Applicant cannot claim any right or interest in the Unit merely by subscribing to the
              application for allotment. The Allotment of the Unit is entirely at the discretion of Sentient Developers
              Private limited. In case of non-allotment, Booking Amount paid will be refunded without
              interest.
            </li>
            <li>&nbsp; The booking amount constitutes a minimum of 10% of the Agreement value of the unit.</li>
            <li>
              &nbsp; Company reserves the right to cancel the allotment and forfeit monies paid if the amounts are not
              paid as per the terms of booking and / or if the amount paid by cheque is dishonoured for non-availability
              of funds or for any other reasons, and / or suppression of information / wrong information of any
              information which is required to be provided at the time of booking resulting in a violation by the
              Applicant. In case the Applicant desires to withdraw the booking, the cancellation amount will be charged
              as a combination of (as applicable)
              <ol type="a">
                <li>&nbsp; Agency Commission, brokerage,</li>
                <li>&nbsp;any Government, levies paid by company,</li>
                <li>
                  &nbsp;Stamp duty charges paid to buy stamp paper for the agreements apart from the booking amount.
                </li>
              </ol>
            </li>
            {/* <div className={classes.tableContent}>
              <table style={{ width: "80%" }} className={classes.table}>
                <tr className={classes.table}>
                  <th className={classes.table}></th>
                  <th className={classes.table} colSpan="4">
                    Type of Unit
                  </th>
                </tr>
                <tr className={classes.table}>
                  <td className={classes.table}> Cancellation</td>
                  <td className={classes.table}>1 BHK </td>
                  <td className={classes.table}>2 BHK </td>
                  <td className={classes.table}>3 BHK </td>
                  <td className={classes.table}>4 BHK </td>
                </tr>
                <tr className={classes.table}>
                  <td className={classes.table}>Within 30 days of booking</td>
                  <td className={classes.table}>50,000</td>
                  <td className={classes.table}>1,00,000</td>
                  <td className={classes.table}>1,50,000 </td>
                  <td className={classes.table}>2,00,000</td>
                </tr>
                <tr className={classes.table}>
                  <td className={classes.table}>30-60 days of booking</td>
                  <td className={classes.table}>1,00,000</td>
                  <td className={classes.table}>2,00,000</td>
                  <td className={classes.table}>3,00,000</td>
                  <td className={classes.table}>4,00,000</td>
                </tr>
                <tr className={classes.table}>
                  <td className={classes.table}>
                    More than 60 days from booking
                  </td>
                  <td className={classes.table} colSpan="4">
                    Full booking amount (limited to a maximum of 10% of cost of
                    apartment)
                  </td>
                </tr>
              </table>
            </div> */}
            <li>
              &nbsp; Post cancellation as per above clause, the balance (if any) will be refunded to the applicant
              within 45 days without any interest thereon. The Applicant has given his / her / their consent for such
              forfeiture.
            </li>
            <li>&nbsp; All payments are subject to the receipt and realisation.</li>
            <li>
              &nbsp; The Applicant shall enter into definitive agreements with the company within 30 (thirty) days from
              the date of allotment letter. In case this is not done, the allotment of the Unit will be deemed as
              cancelled without any further notice unless the Company agrees to extend the timeline for execution of the
              definitive agreements at its sole discretion.
            </li>
            <li>
              &nbsp; The Carpet Area of the Unit, its specifications, sale plan, handing over date, facilities, rights
              and obligations of the Purchaser etc., shall be more clearly defined in the definitive agreements.
            </li>
            <li>
              &nbsp; The Applicant confirms and represents that he / she / they has made payment to the Company only
              towards the Unit and that he / she / they shall not have any claim of any kind whatsoever in any other
              development undertaken by the Company within the Project.
            </li>
            <li>
              &nbsp; Statutory expenses like stamp duty & registration charges for agreements and registering the
              property, additional stamp duty, if demanded by the Special Dy. Commissioner, undervaluation of stamps
              will have to be borne by the Allottee. GST as applicable, increase in existing tax levies and any fresh
              Governmental levies, applicable during the contract period shall be met by the Allottee.
            </li>
            <li>
              &nbsp; The Price list is subject to change from time to time at the sole discretion of the Company and the
              price as prevalent on the date of submitting the Application along with the booking amount shall prevail.
              The price shall be confirmed by the Company when the allotment letter is issued.
            </li>
            <li>
              &nbsp; The Applicant cannot claim shifting of the booking within the project / any other project of the
              Company, unless the Company specifically agrees for the same, and subject to such charges as may be
              leviable in this regard.
            </li>
            <li>
              &nbsp; The transfer of the booking to a third party can be allowed only after the Applicant enters into
              the definitive agreements. The transfer will be allowed solely at the discretion of the company, subject
              to a transfer fee payable based on the prevailing rates as prescribed and execution of necessary documents
              acceptable to the Company.
            </li>
            <li>
              &nbsp; The car park(s) allotment will be done on a first come first serve basis by the Company. Allotment
              of additional car parks is subject to availability and will be done on first come first serve basis.
            </li>
            <li>
              &nbsp; Alterations to the Building Plan: The Applicant has seen and accepted the plans, design and
              specifications and the Applicant authorises the Company to effect suitable and necessary alterations /
              modifications in the layout plan / building plans, designs and specifications as the Company may deem fit
              or as may be directed by any competent authority / (ies).
            </li>
            <li>
              &nbsp; Dimensions and details provided in the accompanying literature are approximate and are subject to
              alteration without notice.
            </li>
            <li>
              &nbsp; This booking is subject to acceptance by Company in writing, and the receipt passed for money does
              not constitute allotment.
            </li>
          </ol>
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default RefundPolicy;
